import {Redirect_Login} from '@/shared/utils'
import {errorText, isAuthError} from '@/shared/dienstplan_api'
import {dp, loadBasis, loadPlan} from './store'

// Mixin of the Dienstplanung pages: loading, messages, error handling.
export default {
  data: () => ({snack: {show: false, text: '', color: 'success'}}),
  computed: {
    dp: () => dp,
    settings: () => dp.basis.settings,
  },
  methods: {
    toast (text, color = 'success') {
      this.snack = {show: true, text, color}
    },
    fail (res) {
      this.hideLoader()
      if (isAuthError(res)) {
        window.location = Redirect_Login
        return
      }
      if (dp.basis.schemaMissing) return
      this.toast(errorText(res), 'red accent-2')
    },
    showLoader () {
      if (!this.loader) this.loader = this.$loading.show()
    },
    hideLoader () {
      if (this.loader) {
        this.loader.hide()
        this.loader = undefined
      }
    },
    // ensure loads base data and the plan of the current range once
    ensure (withPlan = true) {
      this.showLoader()
      return loadBasis()
        .then(() => (withPlan && !dp.plan ? loadPlan() : null))
        .then(() => this.hideLoader(), res => this.fail(res))
    },
    reloadPlan (range) {
      this.showLoader()
      return loadPlan(range).then(() => this.hideLoader(), res => this.fail(res))
    },
  },
}
